import styled from "styled-components";

export const ContainerEdit = styled.div`
  display: flex;
  flex-direction: row;

  .editContainer {
    width: 60%;
  }
`;
export const Name = styled.h2`
  font-family: "Ubuntu";
  font-weight: bold;
  color: ${(props) => props.color};
`;
export const ContainerImage = styled.div`
  width: 100%;
  text-align: center;
`;
export const Container = styled.div`
  overflow: hidden;
  width: 310px;
  margin-top: 20px;
  background: url(${(props) => props.background}) no-repeat left top;
  background-size: contain;
  padding-top: 67px;
  height: 625px;
  .separator {
    width: 100%;
    margin-top: 20px;
  }
`;
export const ContainerHeader = styled.div`
  margin: 0 20px;
  overflow: hidden;
`;
export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const CallButton = styled.button`
  background: ${(props) => props.background};
  border-radius: 10px;
  width: 50%;
  color: ${(props) => props.color};
  border: none;
  padding: 10px;
  margin: 0 10px 0 0;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const CategoryItem = styled.p`
  color: ${(props) => props.color};
  font-size: 18.2438px;
  margin-right: 10px;
  font-family: "Ubuntu";
  font-weight: bold;
  margin: 10px 0;
`;
export const Category = styled.p`
  color: ${(props) => props.color};
  font-size: 24.2438px;
  margin-right: 10px;
  font-family: "Ubuntu";
  font-weight: bold;
  margin: 15px 0;
`;
export const CategoryCarrousel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 170%;
`;
export const ProductList = styled.div``;
export const ProductItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 10px;
`;
export const ProductInfo = styled.div``;
export const ProductTitle = styled.p`
  font-size: 18.2438px;
  font-family: "Ubuntu";
  padding: 0;
  margin: 0;
  color: ${(props) => props.color};
`;
export const ProductImage = styled.img`
  border-radius: 40px;
  height: 70px;
  width: 70px;
`;
export const ProductPrice = styled.p`
  font-family: "Ubuntu";
  font-weight: bold;
  font-size: 18.2438px;
  padding: 0;
  margin: 0;
  color: ${(props) => props.color};
`;

export const ProductDescription = styled.p`
  font-size: 14.1897px;
  padding: 8px 0;
  margin: 0;
  color: #999;
`;
